module.exports = __webpack_public_path__ + "img/simulations-colored.d453cda0.svg";